import { render } from "./auth-password-reset.vue?vue&type=template&id=0cc6bddd&scoped=true"
import script from "./auth-password-reset.vue?vue&type=script&lang=js"
export * from "./auth-password-reset.vue?vue&type=script&lang=js"

import "./auth-password-reset.vue?vue&type=style&index=0&id=0cc6bddd&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc6bddd"]])

export default __exports__